import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { SERVICES, ASSETS } from "@/lib/services";

export default function Services() {
  const { t } = useContent();
  return (
    <div data-testid="services-page">
      <section className="bg-ink-800 text-bone-50 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{ backgroundImage: `url(${ASSETS.library})`, backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-800/70 via-ink-800/85 to-ink-800" />
        <div className="relative section pt-24 pb-20 md:pt-32 md:pb-28">
          <div className="eyebrow !text-gold-400 mb-6">{t("services.eyebrow")}</div>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl">
            {t("services.title")}
          </h1>
          <p className="mt-8 text-xl text-bone-100/80 leading-relaxed max-w-2xl font-light">
            {t("services.subtitle")}
          </p>
        </div>
      </section>

      <section className="section py-20 md:py-28 space-y-px bg-ink-800/10 grid md:grid-cols-1">
        {SERVICES.map((s, idx) => (
          <Link
            to={`/services/${s.slug}`}
            key={s.slug}
            className="group bg-bone-50 p-8 md:p-12 grid md:grid-cols-12 gap-8 items-center hover:bg-ink-800 hover:text-bone-50 transition-colors"
            data-testid={`services-list-item-${s.slug}`}
          >
            <div className="md:col-span-1">
              <span className="font-serif text-3xl text-gold-600">0{idx + 1}</span>
            </div>
            <div className="md:col-span-2">
              <i className={`${s.icon} text-4xl text-gold-600 group-hover:text-gold-400 transition-colors`} />
            </div>
            <div className="md:col-span-7">
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight">
                {t(`service.${s.slug}.title`)}
              </h3>
              <p className="mt-2 opacity-75 leading-relaxed text-sm md:text-base">
                {t(`service.${s.slug}.short`)}
              </p>
            </div>
            <div className="md:col-span-2 md:text-right">
              <span className="inline-flex items-center gap-2 uppercase tracking-[0.22em] text-[10px] text-gold-600 group-hover:text-gold-400">
                Read more <i className="fa-solid fa-arrow-right" />
              </span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
